import { AppConfig } from 'my-constants';
import { BaseService } from 'my-utils/core';

class StaffService extends BaseService {
    serviceUrl = `${AppConfig.API_URL}/portal/staff/`;
}

export default new StaffService()
